/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import Popup from 'reactjs-popup';
import { useSelector, useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import { useTheme } from 'emotion-theming';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import Text from '../../../../shared/components/Text/Text';
import {
  setSelectedItems,
  setExpandedItems,
  setActiveModal,
  setIsSupersetPickerOpen,
  startNewEditBatch,
} from '../../ducks/calendarActions';
import generateUniqueId from '../../../../shared/utils/generateUniqueId';
import SuperSetPickerPopup from './SuperSetPickerPopup';

const SelectedItemsTextAndCheckBoxContainer = styled('div')`
  display: flex;
  background: ${({ theme }) => theme.colors.surface};
  align-items: center;
  gap: ${(props) => (props.isMonthView ? '4px' : '8px')};
  padding-bottom: ${(props) => (props.itemsAreSelected ? '3px' : '8px')};
  padding-top: ${(props) => (props.itemsAreSelected ? '3px' : '8px')};
  padding-left: ${(props) => (props.itemsAreSelected ? '8px' : '2px')};
  padding-right: ${(props) => (props.itemsAreSelected ? '8px' : '2px')};
  width: fit-content;
  border: ${(props) => (props.itemsAreSelected && `1px solid ${props.theme.colors.borderLight}`)};
  border-radius: 4px;
  box-shadow: ${(props) => (props.itemsAreSelected && '0px 4px 8px 0px #3031331A')};
  margin-top: ${(props) => (props.itemsAreSelected && '10px')};
  margin-bottom: ${(props) => (props.itemsAreSelected && '10px')};

  position: ${(props) => (props.itemsAreSelected && 'sticky')};
  top: ${(props) => (props.itemsAreSelected && '10px')};
  background: ${(props) => (props.itemsAreSelected && props.theme.colors.surface)};
  z-index: ${(props) => ((props.itemsAreSelected || props.isMonthView) && 50)};

  .checkbox-input {
    appearance: none; /* Remove default checkbox styling */
    min-width: 18px;
    min-height: 18px;
    max-width: 18px;
    max-height: 18px;
    border: 2px solid ${(props) => (props.isChecked ? props.theme.colors.link : props.theme.colors.borderMedium)};
    border-radius: 4px;
    outline: none;
    cursor: pointer;
    position: relative;
  }

  .checkbox-input:checked::after {
    content: '';
    position: absolute;
    top: 1px;
    left: 5px;
    width: 5px;
    height: 10px;
    border: solid ${(props) => (props.isChecked ? props.theme.colors.link : props.theme.colors.borderMedium)};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    display: block;
  }

 .checkbox-input:indeterminate {
    border-color: ${({ theme }) => theme.colors.link};
  }
  .checkbox-input:indeterminate::after {
    content: '-';
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 31px;
    color: ${({ theme }) => theme.colors.link};
    margin-top: 3px;
  }
`;

const IconsWrapper = styled('div')`
display: flex;
`;
const IconContainer = styled('div')`
display: flex;
cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
border-radius: 4px;
height: ${(props) => (props.isMonthView ? '24px' : '32px')};
width: ${(props) => (props.isMonthView ? '24px' : '32px')};
min-width: ${(props) => (props.isMonthView ? '24px' : '32px')};
align-items: center;
justify-content: center;
:hover {
 background: ${(props) => {
    if (props.disabled) return 'transparent';
    return props.isDeleteIcon ? 'rgba(255, 5, 5, 0.2)' : 'rgba(119, 167, 255, 0.2)';
  }};
}

.icon {
    fill: ${(props) => (props.disabled ? 'rgba(189, 189, 189, 0.5)' : props.theme.colors.textSecondary)};
  }

  &:hover .icon  {
    fill: ${(props) => {
    if (props.disabled) return 'rgba(189, 189, 189, 0.5)';
    return props.isDeleteIcon ? '#FF0505' : props.theme.colors.hover;
  }};
  }

`;

const Divider = styled('div')`
display: flex;
height: 100%;
width: 1px;
background-color: ${({ theme }) => theme.colors.borderLight};
margin-left: 5px;
margin-right: 5px;
`;

const SelectedItemsTextAndCheckBoxContainerWrapper = ({ dayKey, isMonthView = false }) => {
  const dispatch = useDispatch();
  const [expandAll, setExpandAll] = useState(false);
  /** Stable id for the month-only select-all checkbox tooltip. */
  const [checkboxTooltipId] = useState(() => generateUniqueId()?.toString());
  const viewType = useSelector((state) => state.calendar.data.viewType);
  const programType = useSelector((state) => state.calendar.data.programType);
  const isTvMode = useSelector((state) => state.calendar.ui.isTvMode);
  const selectedItems = useSelector((state) => state.calendar.data.selectedItems);
  const expandedItems = useSelector((state) => state.calendar.data.expandedItems);
  const selectedDate = useSelector((state) => state.calendar.data.selectedDate);
  const date = new Date(selectedDate);
  const endpointFormattedDate = moment(dayKey || date).format('YYYY-MM-DD');

  /** here we are conditionally setting calendar items to the true calendar items or
     * the non date based items. We are doing it here so we don't have to write conditionals
     * everywhere we use calendarItems
     */
  const selectedProgramDayNumber = useSelector(
    (state) => state.calendar.data.selectedProgramDayNumber,
  );
  const nonDateBasedProgramItems = useSelector(
    (state) => state.calendar.data.nonDateBasedProgramItems,
  );
  const { colors } = useTheme();
  const calendarItems = programType === 'free-form-program'
    ? useSelector((state) => state.calendar.data.nonDateBasedProgramItems[
      dayKey || selectedProgramDayNumber
    ]?.exercises || [])
    : useSelector((state) => state.calendar.data.calendarItems[
      endpointFormattedDate
    ]?.exercises || []);

  const selectedItemsForDayKey = Object.fromEntries(
    (calendarItems || [])
      .filter((item) => selectedItems?.[item.assignedId])
      .map((item) => [item.assignedId, selectedItems[item.assignedId]]),
  ) || {};

  const isSuperSetDisabled = Object.values(selectedItemsForDayKey || {}).some(
    (item) => item?.type === 'session_break' || item?.type === 'questionnaire',
  );

  const itemIsSelected = (cbItem) => !!selectedItemsForDayKey[cbItem.assignedId];

  /** Calculate if all items are selected for dayKey */
  const allSelected = calendarItems.length > 0
  && Object.keys(selectedItemsForDayKey).length === calendarItems.length
  && calendarItems.every(itemIsSelected);

  /** Calculate if some items are selected */
  const someSelected = calendarItems.some((item) => itemIsSelected(item)) && !allSelected;

  /** Build matching items based on current calendar items */
  const matchingItems = {};
  calendarItems.forEach((item) => {
    if (selectedItems[item.assignedId]) {
      matchingItems[item.assignedId] = selectedItems[item.assignedId];
    }
  });

  useEffect(() => {
    if (calendarItems?.length) {
      setSelectedItems({
        ...selectedItems,
        ...matchingItems,
      });
    }
  }, [calendarItems]);

  /** Handle parent checkbox toggle */
  const handleParentCheckboxChange = (event) => {
    event.stopPropagation();

    if (allSelected) {
      const remaining = { ...selectedItems };

      /** Remove only selected items for this dayKey */
      Object.keys(selectedItemsForDayKey).forEach((key) => {
        delete remaining[key];
      });

      dispatch(setSelectedItems(remaining));
    } else {
      const allItemsObj = {};
      calendarItems.forEach((item) => {
        allItemsObj[item.assignedId] = item;
      });
      dispatch(setSelectedItems({
        ...selectedItems,
        ...allItemsObj,
      }));
    }
  };

  const handleExpandExercises = () => {
    const newExpandedItems = { ...expandedItems };
    Object.keys(selectedItemsForDayKey).forEach((exercise) => {
      newExpandedItems[exercise] = !expandAll;
    });
    /** A coach's expand/collapse ends the current undo batch. */
    dispatch(startNewEditBatch(Object.keys(selectedItemsForDayKey)));
    dispatch(setExpandedItems(newExpandedItems));
  };

  const icons = [
    {
      id: generateUniqueId()?.toString(),
      label: expandAll ? 'Collapse' : 'Expand',
      name: expandAll ? 'collapse' : 'expand2',
      color: colors.textSecondary,
      onClick: () => {
        setExpandAll(!expandAll);
        handleExpandExercises();
      },
      /** Month view has no expand/collapse affordance — drop this action. */
      isExpand: true,
    },
    {
      id: generateUniqueId()?.toString(), label: 'Superset', name: 'superset', color: colors.textSecondary, onClick: () => {},
    },
    /** Hiding copy icon for now, we will wire this up at a later date */
    {
      id: generateUniqueId()?.toString(),
      label: 'Copy',
      name: 'duplicate',
      color: colors.textSecondary,
      onClick: () => {
        const modalData = {
          preSelectedItems: selectedItemsForDayKey,
          skipFirstSlide: true,
        };

        // Add source day metadata for Program Library mode
        if (programType === 'free-form-program' && nonDateBasedProgramItems) {
          const effectiveDayNumber = dayKey || selectedProgramDayNumber;
          const dayData = nonDateBasedProgramItems[effectiveDayNumber];
          if (dayData) {
            modalData.sourceDayNumber = effectiveDayNumber;
            modalData.sourceWeekNumber = dayData.weekNumber;
            modalData.sourceDayInWeek = dayData.dayInWeek;
          }
        }

        dispatch(setActiveModal('copyWorkoutModal', modalData));
      },
      inactive: programType === 'free-form-program',
    },
    {
      id: generateUniqueId()?.toString(),
      label: 'Delete',
      name: 'delete',
      color: colors.textSecondary,
      onClick: () => {
        const selectedItemArray = Object.values(selectedItemsForDayKey || {});
        if (!selectedItemArray.length) return;

        /** Split selected items into preSave vs non-preSave */
        const preSaveItems = selectedItemArray.filter((item) => item.preSave);
        const nonPreSaveItems = selectedItemArray.filter((item) => !item.preSave);

        dispatch(setActiveModal('confirmDeleteModal', {
          isBulkDelete: true,
          bulkDeleteAssignedIds: nonPreSaveItems.map((item) => item.assignedId),
          ...(programType === 'calendar' && { date: endpointFormattedDate }),
          ...(programType === 'free-form-program' && { dayNumber: dayKey || selectedProgramDayNumber }),
          preSaveItems,
        }));
      },
    },
  ];

  if (isTvMode) return null;

  return (
    <SelectedItemsTextAndCheckBoxContainer
      isChecked={allSelected}
      itemsAreSelected={Object?.keys(matchingItems)?.length}
      isMonthView={isMonthView}
      data-month-action-bar={isMonthView ? true : undefined}
    >
      <input
        ref={(el) => {
          if (el) {
          /** Set indeterminate state programmatically */
            el.indeterminate = someSelected;
          }
        }}
        className='checkbox-input'
        type='checkbox'
        name='selectedItems'
        checked={allSelected}
        onClick={handleParentCheckboxChange}
        data-tooltip-id={isMonthView && !Object.keys(matchingItems)?.length ? checkboxTooltipId : undefined}
      />
      {isMonthView && !Object.keys(matchingItems)?.length && (
        <ReactTooltip
          id={checkboxTooltipId}
          place='top'
          content='Click checkbox to select all, or Shift + Click to select or deselect individual items.'
          style={{
            backgroundColor: 'rgba(68, 68, 68, 1)',
            color: 'white',
            fontFamily: 'Nunito Sans',
            fontSize: '13px',
            maxWidth: '200px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
          }}
        />
      )}
      <Text fontSize={isMonthView ? '12px' : undefined} color={Object.keys(matchingItems)?.length ? colors.link : colors.textSecondary} fontWeight={Object.keys(matchingItems)?.length && 700}>
        {`Selected (${Object.keys(matchingItems)?.length})`}
      </Text>
      {Object.keys(matchingItems)?.length ? (
        <>
          <Divider />
          <IconsWrapper>
            {icons.map((icon) => {
              if (icon.inactive) return null;
              /** Month view drops the expand/collapse action. */
              if (isMonthView && icon.isExpand) return null;
              return (
                <>
                  {icon.label === 'Superset' ? (
                    <Popup
                      position='bottom left'
                      arrow={false}
                      offsetX={-4}
                      on='click'
                      onOpen={() => dispatch(setIsSupersetPickerOpen(true))}
                      onClose={() => dispatch(setIsSupersetPickerOpen(false))}
                      trigger={(
                        <IconContainer isMonthView={isMonthView} disabled={isSuperSetDisabled} key={icon.name} onClick={icon.onClick} data-tooltip-id={icon.id}>
                          <IcomoonReact
                            iconSet={iconSet}
                            size={isMonthView ? 24 : 30}
                            icon={icon.name}
                            className='icon'
                          />
                        </IconContainer>
                      )}
                    >
                      {(close) => (
                        !isSuperSetDisabled && (
                        <SuperSetPickerPopup
                          content={{ isMultiSelect: true, selectedIems: selectedItemsForDayKey }}
                          left={0}
                          top={0}
                          bulkActionPicker
                          closeBulkActionPicker={close}
                          effectiveDate={(viewType === 'weekView' || isMonthView) ? endpointFormattedDate : null}
                          dayNumber={viewType === 'weekView' ? dayKey : null}
                        />
                        )
                      )}
                    </Popup>
                  ) : (
                    <IconContainer isMonthView={isMonthView} key={icon.name} onClick={icon.onClick} data-tooltip-id={icon.id} isDeleteIcon={icon.label === 'Delete'}>
                      <IcomoonReact
                        iconSet={iconSet}
                        size={isMonthView ? 13 : 16}
                        icon={icon.name}
                        className='icon'
                      />
                    </IconContainer>
                  )}
                  {icon.label !== 'Superset' && !isSuperSetDisabled && (
                  <ReactTooltip
                    id={icon.id}
                    place='top'
                    content={icon?.label === 'Copy' ? 'Copy Selected Items' : icon?.label}
                    style={{
                      backgroundColor: 'rgba(68, 68, 68, 1)',
                      color: colors.white,
                      fontFamily: 'Nunito Sans',
                      fontSize: '13px',
                    }}
                  />
                  )}
                </>
              );
            })}
          </IconsWrapper>
        </>
      ) : null}
    </SelectedItemsTextAndCheckBoxContainer>
  );
};

export default SelectedItemsTextAndCheckBoxContainerWrapper;
